// import { useSession } from "@/components/SupabaseProvider";
"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import BarsMenu from "./BarsMenu";
import Button from "./Button";
import ResourcesNav from "./ResourcesNav";

interface NavProps {
  className?: string;
}

export const DISCORD_LINK = "https://discord.gg/KcAcHdrSQU";

const Nav = (props: NavProps) => {
  const pathname = usePathname();
  const isApiPage = pathname === "/api";
  const pricingHref = isApiPage
    ? "https://docs.klap.app"
    : "/pricing";

  const buildBody = () => {
    return (
      <>
        <li>
          <ResourcesNav />
        </li>
        {/* <li>
          <ToolsNav />
        </li> */}
        <li>
          <Link
            className="overflow-ellipsis overflow-hidden"
            href={pricingHref}
            {...(isApiPage ? { target: "_blank", rel: "noreferrer" } : {})}
          >
            <Button
              size="m"
              variant="tertiary"
              onClick={() => {}}
              className="w-full"
              align="start"
            >
              Pricing
            </Button>
          </Link>
        </li>
      </>
    );
  };
  return (
    <nav className={`${props.className} flex gap-2`}>
      <BarsMenu className="block md:hidden">
        {
          <ul className="flex flex-col gap-2">
            {buildBody()}
          </ul>
        }
      </BarsMenu>
      <ul className="hidden gap-2 md:flex">{buildBody()}</ul>
    </nav>
  );
};

export default Nav;
